import Aos from 'aos';
import { useEffect } from 'react';
import Me from '../../assests/bg-photo.jpg';
import HeaderSocials from './HeaderSocials';
import './Home.css';
import ScrollDown from './ScrollDown';
import Shapes from './Shapes';

const Home = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
      once: false,
    });
  }, []);
  return (
    <section data-aos="fade-up" className="home container" id="home">
      <div className="intro">
        <img src={Me} alt="" className="home__img lg:ml-32 md:ml-16 ml-20" />
        <h1 className="home__name">Abdulaziz Rustamov</h1>
        <span className="home__education">I'm a Full-Stack developer</span>

        <HeaderSocials />

        <a href="#contact" className="btn">
          Hire Me
        </a>

        <ScrollDown />
      </div>

      <Shapes />
    </section>
  );
};

export default Home;
